module.exports = __webpack_public_path__ + "img/ohbara.c7fc37c1.jpg";